import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  Title
} from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../../FirebaseConfig";

// Register required Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DonutChart = ({ eventName }) => {
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: []
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const solveCountsRef = doc(
          db,
          `Events/${eventName}/Statistics`,
          "categoryCounts"
        );
        const categoryCountsDoc = await getDoc(solveCountsRef);

        if (categoryCountsDoc.exists()) {
          const data = categoryCountsDoc.data();
          
          // Convert the Firebase data into chart format
          setChartData({
            labels: Object.keys(data),
            datasets: [
              {
                data: Object.values(data),
                backgroundColor: [
                    'rgba(255, 99, 132, 0.3)',    // Original
                    'rgba(54, 162, 235, 0.3)',    // Original
                    'rgba(255, 206, 86, 0.3)',    // Original
                    'rgba(75, 192, 192, 0.3)',    // Original
                    'rgba(153, 102, 255, 0.3)',   // Original
                    'rgba(255, 159, 64, 0.3)',    // Original
                    'rgba(201, 203, 207, 0.3)',   // Original
                    'rgba(128, 0, 128, 0.3)',     // New
                    'rgba(0, 128, 128, 0.3)',     // New
                    'rgba(128, 128, 0, 0.3)',     // New
                    'rgba(0, 255, 127, 0.3)',     // New
                    'rgba(255, 20, 147, 0.3)',    // New
                    'rgba(70, 130, 180, 0.3)',    // New
                    'rgba(105, 105, 105, 0.3)',   // New
                    'rgba(255, 140, 0, 0.3)',     // New
                    'rgba(102, 205, 170, 0.3)',   // New
                    'rgba(240, 128, 128, 0.3)',   // New
                    'rgba(135, 206, 235, 0.3)',   // New
                    'rgba(218, 112, 214, 0.3)',   // New
                    'rgba(0, 191, 255, 0.3)',     // New
                    'rgba(47, 79, 79, 0.3)',      // New
                    'rgba(255, 69, 0, 0.3)'       // New
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',      // Original
                    'rgba(54, 162, 235, 1)',      // Original
                    'rgba(255, 206, 86, 1)',      // Original
                    'rgba(75, 192, 192, 1)',      // Original
                    'rgba(153, 102, 255, 1)',     // Original
                    'rgba(255, 159, 64, 1)',      // Original
                    'rgba(201, 203, 207, 1)',     // Original
                    'rgba(128, 0, 128, 1)',       // New
                    'rgba(0, 128, 128, 1)',       // New
                    'rgba(128, 128, 0, 1)',       // New
                    'rgba(0, 255, 127, 1)',       // New
                    'rgba(255, 20, 147, 1)',      // New
                    'rgba(70, 130, 180, 1)',      // New
                    'rgba(105, 105, 105, 1)',     // New
                    'rgba(255, 140, 0, 1)',       // New
                    'rgba(102, 205, 170, 1)',     // New
                    'rgba(240, 128, 128, 1)',     // New
                    'rgba(135, 206, 235, 1)',     // New
                    'rgba(218, 112, 214, 1)',     // New
                    'rgba(0, 191, 255, 1)',       // New
                    'rgba(47, 79, 79, 1)',        // New
                    'rgba(255, 69, 0, 1)'         // New
                ],
                borderWidth: 1,
              },
            ],
          });
        }
      } catch (error) {
        console.error("Error fetching category counts:", error);
      } finally {
        setLoading(false);
      }
    };

    if (eventName) {
      fetchData();
    }
  }, [eventName]);

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxWidth: 20,
          usePointStyle: true,
          font: {
            size: 14,
          },
        },
      },
    },
    cutout: '70%'
  };

  if (loading) {
    return <div className="w-full h-64 flex items-center justify-center">Loading chart data...</div>;
  }

  return (
    <div className="w-full max-w-md mx-auto p-4">
      {chartData.labels.length > 0 ? (
        <Doughnut data={chartData} options={options} />
      ) : (
        <div className="text-center text-gray-600">No data available</div>
      )}
    </div>
  );
};

export default DonutChart;